/**
 *   Copyright (C) Cylergie - All Rights Reserved
 * Proprietary and confidential
 * Subject to French law on copyright
 * Unauthorized copying of this file, via any medium is strictly prohibited: https://crigen.myengie.com/copyright
 * Any request for authorization of use should be addressed by email to"mvalo.bvt@engie.com" with the subject "Copyright Statement in Source Code"
 * Written in 2024
 */

/* eslint-disable */
import { createStore } from 'vuex';
import boilerplate from './modules/boilerplate';
import global from './modules/global';
import wizard from './modules/wizard';
import http from '@/services/api/internal/client';

const store = createStore({
  strict: true,
  modules: {
    boilerplate,
    global,
    wizard,
  },

  state: {
    error: false,
    error_message: '',
    loading: false,
    // CHECKBOXES related states
    id_status: false,
    site_status: false,
    boiler_status: false,
    // SILOS related states
    silo_index: 0,
    silos: [],
    plannings: [],
    // BOILERS related states
    boiler_index: 0,
    boilers: [],
    // USER related states
    users: [],
    user: {},
    // CONFIG related states
    configs: [],
    config: {},
    // SITE related states
    sites: [],
    site: {},
    plants: [],
    plant: {},
    // CONSTRAINT related state
    rules: [],
    loads: [],

    //PREVISION related state
    snapshots: [],
    appros: [],
    woods: [],
    meteos: [],
    demands: [],
  },
  mutations: {
    // USER related mutations
    SET_USER_LIST(state, users) {
      state.users = users;
    },
    SET_USER(state, user) {
      state.user = user;
    },
    SET_AUTH(state, sub) {
      state.user.sub = sub;
    },
    SET_ROLE(state, role) {
      state.user.role = role;
    },
    ADD_USER(state, user) {
      state.users.push(user);
    },
    REM_USER(state, user) {
      let index = state.users.indexOf(user);
      state.users.splice(index, 1);
    },

    // CONFIG related mutations
    SET_CONFIG_LIST(state, configs) {
      state.configs = configs;
    },
    SET_STEP(state, step) {
      state.config.step = step;
    },
    SET_CONFIG(state, config) {
      state.config = config;
    },
    ADD_CONFIG(state, config) {
      state.configs.push(config);
    },
    REM_CONFIG(state, index) {
      state.configs.splice(index, 1);
    },
    UPD_CONFIG(state, config) {
      console.log('UPD_CONFIG');
      console.log(config);
      let index = state.configs.findIndex((c) => c.id === config.id);
      if (index !== -1) {
        state.configs.splice(index, 1, config);
      }
    },

    // SITE related mutations
    SET_SITE_LIST(state, sites) {
      state.sites = sites;
    },
    SET_SITE(state, site) {
      state.site = site;
    },
    SET_SITE_ID(state, id) {
      state.site.id = id;
    },
    ADD_SITE(state, site) {
      state.sites.push(site);
    },
    REM_SITE(state, index) {
      state.sites.splice(index, 1);
    },
    UPD_SITE(state, site) {
      let index = state.sites.findIndex((s) => s.id === site.id);
      if (index !== -1) {
        state.sites.splice(index, 1, site);
      }
    },

    // PLANT related mutations
    SET_PLANT_LIST(state, plants) {
      state.plants = plants;
    },
    SET_PLANT(state, plant) {
      state.plant = plant;
    },
    SET_PLANT_ID(state, id) {
      state.plant.id = id;
    },
    ADD_PLANT(state, plant) {
      state.plants.push(plant);
    },
    REM_PLANT(state, index) {
      state.plants.splice(index, 1);
    },
    UPD_PLANT(state, plant) {
      let index = state.plants.findIndex((p) => p.id === plant.id);
      if (index !== -1) {
        state.plants.splice(index, 1, plant);
      }
    },

    // SILOS related mutations
    SET_SILO_LIST(state, silos) {
      state.silos = silos;
    },
    SET_SILO_INDEX(state, index) {
      state.silo_index = index;
    },
    ADD_SILO(state, silo) {
      state.silos.push(silo);
    },
    REM_SILO(state, silo_index) {
      console.log('REM_SILO', silo_index);
      state.silos.splice(silo_index, 1);
    },
    UPD_SILO(state, silo) {
      console.log('UPD_SILO');
      console.log(silo);
      let index = state.silos.findIndex((s) => s.id === silo.id);
      if (index !== -1) {
        state.silos.splice(index, 1, silo);
      }
    },

    // BOILERS related mutations
    SET_BOILER_LIST(state, boilers) {
      state.boilers = boilers;
    },
    SET_BOILER_INDEX(state, index) {
      state.boiler_index = index;
    },
    ADD_BOILER(state, boiler) {
      state.boilers.push(boiler);
    },
    REM_BOILER(state, index) {
      state.boilers.splice(index, 1);
    },
    UPD_BOILER(state, boiler) {
      console.log('UPD_BOILER');
      console.log(boiler);
      let index = state.boilers.findIndex((b) => b.id === boiler.id);
      if (index !== -1) {
        state.boilers.splice(index, 1, boiler);
      }
    },

    // PLANNING related mutations
    SET_PLANNING_LIST(state, plannings) {
      state.plannings = plannings;
    },
    ADD_PLANNING(state, planning) {
      state.plannings.push(planning);
    },
    REM_PLANNING(state, index) {
      state.plannings.splice(index, 1);
    },
    UPD_PLANNING(state, planning) {
      let index = state.plannings.findIndex((p) => p.id === planning.id);
      if (index !== -1) {
        state.plannings.splice(index, 1, planning);
      }
    },

    // CONSTRAINT related mutations
    SET_RULE_LIST(state, rules) {
      state.rules = rules;
    },
    ADD_RULE(state, rule) {
      state.rules.push(rule);
    },
    REM_RULE(state, index) {
      state.rules.splice(index, 1);
    },
    UPD_RULE(state, rule) {
      let index = state.rules.findIndex((r) => r.id === rule.id);
      if (index !== -1) {
        state.rules.splice(index, 1, rule);
      }
    },

    SET_LOAD_LIST(state, loads) {
      state.loads = loads;
    },
    ADD_LOAD(state, load) {
      state.loads.push(load);
    },
    REM_LOAD(state, index) {
      state.loads.splice(index, 1);
    },
    UPD_LOAD(state, load) {
      let index = state.loads.findIndex((l) => l.id === load.id);
      if (index !== -1) {
        state.loads.splice(index, 1, load);
      }
    },

    // CHECKBOXES related mutations
    TOGGLE_ID_STATUS(state) {
      state.id_status = !state.id_status;
    },
    TOGGLE_SITE_STATUS(state) {
      state.site_status = !state.site_status;
    },
    TOGGLE_BOILER_STATUS(state) {
      state.boiler_status = !state.boiler_status;
    },

    // ERROR related mutations
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_ERROR_MESSAGE(state, error_message) {
      state.error_message = error_message;
    },

    // LOADING related mutations
    SET_LOADING(state, loading) {
      state.loading = loading;
    },

    // PREVISION related mutations
    SET_SNAPSHOT_LIST(state, snapshots) {
      state.snapshots = snapshots;
    },
    SET_APPRO_LIST(state, appros) {
      state.appros = appros;
    },
    SET_WOOD_LIST(state, woods) {
      state.woods = woods;
    },
    SET_METEO_LIST(state, meteos) {
      state.meteos = meteos;
    },
    SET_DEMAND_LIST(state, demands) {
      state.demands = demands;
    },
    ADD_SNAPSHOT(state, snapshot) {
      state.snapshots.push(snapshot);
    },
    ADD_APPRO(state, appro) {
      state.appros.push(appro);
    },
    ADD_WOOD(state, wood) {
      state.woods.push(wood);
    },
    ADD_METEO(state, meteo) {
      state.meteos.push(meteo);
    },
    ADD_DEMAND(state, demand) {
      state.demands.push(demand);
    },
    REM_SNAPSHOT(state, index) {
      state.snapshots.splice(index, 1);
    },
    REM_APPRO(state, index) {
      state.appros.splice(index, 1);
    },
    REM_WOOD(state, index) {
      state.woods.splice(index, 1);
    },
    REM_METEO(state, index) {
      state.meteos.splice(index, 1);
    },
    REM_DEMAND(state, index) {
      state.demands.splice(index, 1);
    },
    UPD_SNAPSHOT(state, snapshot) {
      let index = state.snapshots.findIndex((s) => s.id === snapshot.id);
      if (index !== -1) {
        state.snapshots.splice(index, 1, snapshot);
      }
    },
    UPD_APPRO(state, appro) {
      let index = state.appros.findIndex((a) => a.id === appro.id);
      if (index !== -1) {
        state.appros.splice(index, 1, appro);
      }
    },
    UPD_WOOD(state, wood) {
      let index = state.woods.findIndex((w) => w.id === wood.id);
      if (index !== -1) {
        state.woods.splice(index, 1, wood);
      }
    },
    UPD_METEO(state, meteo) {
      let index = state.meteos.findIndex((m) => m.id === meteo.id);
      if (index !== -1) {
        state.meteos.splice(index, 1, meteo);
      }
    },
    UPD_DEMAND(state, demand) {
      let index = state.demands.findIndex((d) => d.id === demand.id);
      if (index !== -1) {
        state.demands.splice(index, 1, demand);
      }
    },
  },
  actions: {
    // USER related actions
    getUserList({ commit }) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .get('/users')
        .then((response) => {
          commit('SET_USER_LIST', response.data);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    getUser({ commit }, id) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .get(`/users/${id}`)
        .then((response) => {
          commit('SET_USER', response.data);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    addUser({ commit }, user) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .post('/users', user)
        .then((response) => {
          commit('ADD_USER', response.data);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    remUser({ commit }, user) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .delete(`/users/${user.id}`)
        .then(() => {
          commit('REM_USER', user);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },

    // CONFIG related actions
    getConfigList({ commit }) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .get('/configs')
        .then((response) => {
          commit('SET_CONFIG_LIST', response.data);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    getConfig({ commit }, id) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .get(`/configs/${id}`)
        .then((response) => {
          commit('SET_CONFIG', response.data);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    addConfig({ commit }, config) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .post('/configs', config)
        .then((response) => {
          commit('ADD_CONFIG', response.data);
          commit('SET_CONFIG', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },
    remConfig({ commit }, index) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .delete(`/configs/${index}`)
        .then(() => {
          commit('REM_CONFIG', index);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    updConfig({ commit }, config) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .put(`/configs/${config.id}`, config)
        .then((response) => {
          commit('UPD_CONFIG', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },

    // SITE related actions
    getSiteList({ commit }) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .get('/sites')
        .then((response) => {
          commit('SET_SITE_LIST', response.data);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    getSite({ commit }, id) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .get(`/sites/${id}`)
        .then((response) => {
          commit('SET_SITE', response.data);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    addSite({ commit }, site) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .post('/sites', site)
        .then((response) => {
          commit('ADD_SITE', response.data);
          commit('SET_SITE', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },
    remSite({ commit }, index) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .delete(`/sites/${index}`)
        .then(() => {
          commit('REM_SITE', index);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    updSite({ commit }, site) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .put(`/sites/${site.id}`, site)
        .then((response) => {
          commit('UPD_SITE', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },

    // PLANT related actions
    getPlantList({ commit }) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .get('/plants')
        .then((response) => {
          commit('SET_PLANT_LIST', response.data);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    getPlant({ commit }, id) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .get(`/plants/${id}`)
        .then((response) => {
          commit('SET_PLANT', response.data);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    addPlant({ commit }, plant) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .post('/plants', plant)
        .then((response) => {
          commit('ADD_PLANT', response.data);
          commit('SET_PLANT', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },
    remPlant({ commit }, index) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .delete(`/plants/${index}`)
        .then(() => {
          commit('REM_PLANT', index);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    updPlant({ commit }, plant) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .put(`/plants/${plant.id}`, plant)
        .then((response) => {
          commit('UPD_PLANT', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },

    // SILOS related actions
    getSiloList({ commit }) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .get('/silos')
        .then((response) => {
          commit('SET_SILO_LIST', response.data);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    addSilo({ commit }, silo) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .post('/silos', silo)
        .then((response) => {
          commit('ADD_SILO', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },
    remSilo({ commit }, silo) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .delete(`/silos/${silo.id}`)
        .then(() => {
          commit('REM_SILO', silo.index);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    updSilo({ commit }, silo) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .put(`/silos/${silo.id}`, silo)
        .then((response) => {
          commit('UPD_SILO', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },

    // BOILERS related actions
    getBoilerList({ commit }) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .get('/boilers')
        .then((response) => {
          commit('SET_BOILER_LIST', response.data);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    addBoiler({ commit }, boiler) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .post('/boilers', boiler)
        .then((response) => {
          commit('ADD_BOILER', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },
    remBoiler({ commit }, boiler) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .delete(`/boilers/${boiler.id}`)
        .then(() => {
          commit('REM_BOILER', boiler.index);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    updBoiler({ commit }, boiler) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .put(`/boilers/${boiler.id}`, boiler)
        .then((response) => {
          commit('UPD_BOILER', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },

    // PLANNING related actions
    getPlanningList({ commit }) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .get('/plannings')
        .then((response) => {
          commit('SET_PLANNING_LIST', response.data);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    addPlanning({ commit }, planning) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .post('/plannings', planning)
        .then((response) => {
          commit('ADD_PLANNING', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },
    remPlanning({ commit }, planning) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .delete(`/plannings/${planning.id}`)
        .then(() => {
          commit('REM_PLANNING', planning.index);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    updPlanning({ commit }, planning) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .put(`/plannings/${planning.id}`, planning)
        .then((response) => {
          commit('UPD_PLANNING', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },

    // CONSTRAINT related actions
    getRuleList({ commit }) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .get('/rules')
        .then((response) => {
          commit('SET_RULE_LIST', response.data);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    addRule({ commit }, rule) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .post('/rules', rule)
        .then((response) => {
          commit('ADD_RULE', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },
    remRule({ commit }, rule) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .delete(`/rules/${rule.id}`)
        .then(() => {
          commit('REM_RULE', rule.index);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    updRule({ commit }, rule) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .put(`/rules/${rule.id}`, rule)
        .then((response) => {
          commit('UPD_RULE', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },

    getLoadList({ commit }) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .get('/loads')
        .then((response) => {
          commit('SET_LOAD_LIST', response.data);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    addLoad({ commit }, load) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .post('/loads', load)
        .then((response) => {
          commit('ADD_LOAD', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },
    remLoad({ commit }, load) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .delete(`/loads/${load.id}`)
        .then(() => {
          commit('REM_LOAD', load.index);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    updLoad({ commit }, load) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .put(`/loads/${load.id}`, load)
        .then((response) => {
          commit('UPD_LOAD', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },

    // PREVISION related actions
    getSnapshotList({ commit }) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .get('/snapshots')
        .then((response) => {
          commit('SET_SNAPSHOT_LIST', response.data);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    getApproList({ commit }) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .get('/appros')
        .then((response) => {
          commit('SET_APPRO_LIST', response.data);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    getWoodList({ commit }) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .get('/woods')
        .then((response) => {
          commit('SET_WOOD_LIST', response.data);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    getMeteoList({ commit }) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .get('/meteos')
        .then((response) => {
          commit('SET_METEO_LIST', response.data);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    getDemandList({ commit }) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .get('/demands')
        .then((response) => {
          commit('SET_DEMAND_LIST', response.data);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    addSnapshot({ commit }, snapshot) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .post('/snapshots', snapshot)
        .then((response) => {
          commit('ADD_SNAPSHOT', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },
    addAppro({ commit }, appro) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .post('/appros', appro)
        .then((response) => {
          commit('ADD_APPRO', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },
    addWood({ commit }, wood) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .post('/woods', wood)
        .then((response) => {
          commit('ADD_WOOD', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },
    addMeteo({ commit }, meteo) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .post('/meteos', meteo)
        .then((response) => {
          commit('ADD_METEO', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },
    addDemand({ commit }, demand) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .post('/demands', demand)
        .then((response) => {
          commit('ADD_DEMAND', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },
    remSnapshot({ commit }, snapshot) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .delete(`/snapshots/${snapshot.id}`)
        .then(() => {
          commit('REM_SNAPSHOT', snapshot.index);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    remAppro({ commit }, appro) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .delete(`/appros/${appro.id}`)
        .then(() => {
          commit('REM_APPRO', appro.index);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    remWood({ commit }, wood) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .delete(`/woods/${wood.id}`)
        .then(() => {
          commit('REM_WOOD', wood.index);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    remMeteo({ commit }, meteo) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .delete(`/meteos/${meteo.id}`)
        .then(() => {
          commit('REM_METEO', meteo.index);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    remDemand({ commit }, demand) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      http
        .delete(`/demands/${demand.id}`)
        .then(() => {
          commit('REM_DEMAND', demand.index);
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
        });
    },
    updSnapshot({ commit }, snapshot) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .put(`/snapshots/${snapshot.id}`, snapshot)
        .then((response) => {
          commit('UPD_SNAPSHOT', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },
    updAppro({ commit }, appro) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .put(`/appros/${appro.id}`, appro)
        .then((response) => {
          commit('UPD_APPRO', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },
    updWood({ commit }, wood) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .put(`/woods/${wood.id}`, wood)
        .then((response) => {
          commit('UPD_WOOD', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },
    updMeteo({ commit }, meteo) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .put(`/meteos/${meteo.id}`, meteo)
        .then((response) => {
          commit('UPD_METEO', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },
    updDemand({ commit }, demand) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);
      return http
        .put(`/demands/${demand.id}`, demand)
        .then((response) => {
          commit('UPD_DEMAND', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          commit('SET_ERROR', true);
          commit('SET_ERROR_MESSAGE', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },
  },
  getters: {
    // USER related getters
    getUsers: (state) => state.users,
    getUser: (state) => state.user,

    // CONFIG related getters
    getConfigs: (state) => state.configs,
    getConfig: (state) => state.config,

    // SITE related getters
    getSites: (state) => state.sites,
    getSite: (state) => state.site,
    getPlants: (state) => state.plants,
    getPlant: (state) => state.plant,

    // SILOS related getters
    getSilos: (state) => state.silos,
    getSiloIndex: (state) => state.silo_index,

    // BOILERS related getters
    getBoilers: (state) => state.boilers,
    getBoilerIndex: (state) => state.boiler_index,

    // PLANNING related getters
    getPlannings: (state) => state.plannings,

    // CONSTRAINT related getters
    getRules: (state) => state.rules,
    getLoads: (state) => state.loads,

    // CHECKBOXES related getters
    getIDStatus: (state) => state.id_status,
    getSiteStatus: (state) => state.site_status,
    getBoilerStatus: (state) => state.boiler_status,

    // ERROR related getters
    getError: (state) => state.error,
    getErrorMessage: (state) => state.error_message,

    // LOADING related getters
    getLoading: (state) => state.loading,

    // PREVISION related getters
    getSnapshots: (state) => state.snapshots,
    getAppros: (state) => state.appros,
    getWoods: (state) => state.woods,
    getMeteos: (state) => state.meteos,
    getDemands: (state) => state.demands,
  },
});

export default store;
